

export function MarkdownToHTML(
    src: string,
    allowImageClick: boolean,
) {

    var rx_lt = /</g;
    var rx_gt = />/g;
    var rx_space = /\t|\r|\uf8ff/g;
    var rx_escape = /\\([\\\|`*_{}\[\]()#+\-~])/g;
    var rx_hr = /^([*\-=_] *){3,}$/gm;
    var rx_blockquote = /\n *&gt; *([^]*?)(?=(\n|$){2})/g;
    var rx_list = /\n( *)(?:[*\-+]|((\d+)|([a-z])|[A-Z])[.)]) +([^]*?)(?=(\n|$){2})/g;
    var rx_listjoin = /<\/(ol|ul)>\n\n<\1>/g;
    var rx_highlight = /(^|[^A-Za-z\d\\])(([*_])|(~)|(\^)|(--)|(\+\+)|`)(\2?)([^<]*?)\2\8(?!\2)(?=\W|_|$)/g;
    var rx_code = /\n((```|~~~).*\n?([^]*?)\n?\2|((    .*?\n)+))/g;
    // image or video
    var rx_link = /((!?|\#?)\[(.*?)\]\((.*?)( ".*")?\)|\\([\\`*_{}\[\]()#+\-.!~]))/g;
    var rx_table = /\n(( *\|.*?\| *\n)+)/g;
    var rx_thead = /^.*\n( *\|( *\:?-+\:?-+\:? *\|)* *\n|)/;
    var rx_row = /.*\n/g;
    var rx_cell = /\||(.*?[^\\])\|/g;
    var rx_heading = /(?=^|>|\n)([>\s]*?)(#{1,6}) (.*?)( #*)? *(?=\n|$)/g;
    var rx_para = /(?=^|>|\n)\s*\n+([^<]+?)\n+\s*(?=\n|<|$)/g;
    var rx_stash = /-\d+\uf8ff/g;

    function replace(rex: RegExp, fn: any) {
        src = src.replace(rex, fn);
    }

    function element(tag: string, content: string): string {
        return '<' + tag + '>' + content + '</' + tag + '>';
    }

    function blockquote(src: string): string {
        return src.replace(rx_blockquote, (all: string, content: string): string => {
            return element('blockquote', blockquote(highlight(content.replace(/^ *&gt; */gm, ''))));
        });
    }
    function list(src: string): string {
        return src.replace(rx_list, function (all, ind, ol, num, low, content) {
            var entry = element('li', highlight(content.split(
                RegExp('\n ?' + ind + '(?:(?:\\d+|[a-zA-Z])[.)]|[*\\-+]) +', 'g')).map(list).join('</li><li>')));

            return '\n' + (ol
                ? '<ol start="' + (num
                    ? ol + '">'
                    : parseInt(ol, 36) - 9 + '" style="list-style-type:' + (low ? 'low' : 'upp') + 'er-alpha">') + entry + '</ol>'
                : element('ul', entry));
        });
    }

    function highlight(src: string): string {
        return src.replace(rx_highlight, function (all, _, p1, emp, sub, sup, small, big, p2, content) {
            return _ + element(
                emp ? (p2 ? 'strong' : 'em')
                    : sub ? (p2 ? 's' : 'sub')
                        : sup ? 'sup'
                            : small ? 'small'
                                : big ? 'big'
                                    : 'code',
                highlight(content));
        });
    }

    function unesc(str: string): string {
        return str.replace(rx_escape, '$1');
    }

    var stash: string[] = [];
    var si = 0;

    src = '\n' + src + '\n';

    replace(rx_lt, '&lt;');
    replace(rx_gt, '&gt;');
    replace(rx_space, '  ');

    // blockquote
    src = blockquote(src);

    // horizontal rule
    replace(rx_hr, '<hr/>');

    // list
    src = list(src);
    replace(rx_listjoin, '');

    // code
    replace(rx_code, (all: string, p1: string, p2: string, p3: string, p4: string): string => {
        stash[--si] = element('pre', element('code', p3 || p4.replace(/^    /gm, '')));
        return si + '\uf8ff' as string;
    });

    // link or image
    replace(rx_link, function (all: string, p1: string, p2: string, p3: string, p4: string, p5: string, p6: string) {
        let value = '';
        // console.log(all,p1,p2,p3,p4,p5,p6)


        if (p4) {
            if (p2) {

                const src = p4.split(",")[0];
                const size = p4.split(",")[1] || 0;
                const fileId = p4.split(",")[2] || '';
                const firstChar = all.split('').shift();

                if (allowImageClick) {
                    if (firstChar === '#') {
                        if (!!size) {
                            value = `
                            <video 
                                loading="lazy"
                                src="${src}" 
                                alt="${p3}" 
                                width=${size}
                                controls 
                                style="cursor: default;"
                                >
                            </video>
                        `
                        } else {
                            value = `
                            <video 
                                loading="lazy"
                                src="${src}" 
                                alt="${p3}" 
                                controls 
                                style="cursor: default;"
                                >
                            </video>
                        `
                        }
                    } else if (firstChar === '!') {

                        if (!!size) {
                            value = `<br><a href="${src}" target="_blank"><img 
                            loading="lazy"
                            src="${src}" 
                            alt="${p3}" 
                            width=${size}px /></a>`;
                        } else {
                            value = `<br><a href="${src}" target="_blank"><img 
                            loading="lazy"
                            src="${src}" 
                            alt="${p3}" /></a>`;
                        }
                    }
                } else {
                    if (firstChar === '#') {
                        if (!!size) {
                            value = `
                            <video 
                                loading="lazy"
                                src="${src}" 
                                alt="${p3}" 
                                width=${size}
                                controls 
                                style="cursor: default;"
                                >
                            </video>
                        `
                        } else {
                            value = `
                            <video 
                                loading="lazy"
                                src="${src}" 
                                alt="${p3}" 
                                controls 
                                style="cursor: default;"
                                >
                            </video>
                        `
                        }
                    } else if (firstChar === '!') {

                        if (!!size) {
                            value = `<br><img 
                            loading="lazy"
                            src="${src}" 
                            alt="${p3}" 
                            width=${size}px 
                            style="cursor: default;" />`;
                        } else {
                            value = `<br><img 
                            loading="lazy"
                            src="${src}" 
                            alt="${p3}" 
                            style="cursor: default;" />`;
                        }
                    }
                }






            } else {
                value = '<a style="width: fit-content;" class="button" target="_blank" href="' + p4 + '">' + unesc(highlight(p3)) + '</a>';
            }
        } else {
            value = p6;
        }

        stash[--si] = value;
        return si + '\uf8ff';

    });

    // table
    replace(rx_table, function (all: string, table: string) {
        var sep = table.match(rx_thead)![1];
        return '\n' + element('table',
            table.replace(rx_row, function (row, ri) {
                return row == sep ? '' : element('tr', row.replace(rx_cell, function (all, cell, ci) {

                    return ci ? element(sep && !ri ? 'th' : 'td', unesc(highlight(cell.replace(/&lt;br&gt;/g, "<br>") || ''))) : ''
                }))
            })
        )
    });

    // heading
    replace(rx_heading, function (all: string, _: string, p1: string, p2: string) { return _ + element('h' + p1.length, unesc(highlight(p2))) });

    // paragraph
    replace(rx_para, function (all: string, content: string) { return element('p', unesc(highlight(content))) });

    // stash
    replace(rx_stash, function (all: string) { return stash[parseInt(all)] });


    const spanOpenTagRegex = /&lt;span/g;
    const spanCloseTagRegex = /&lt;\/span/g;

    // This will correctly translate the unicode characters to legit span tags
    src = src.replace(spanOpenTagRegex, '<span');
    src = src.replace(spanCloseTagRegex, '</span');
    src = src.replace(/&gt;/g, '>');



    return src.trim();
};